<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "AgencyProjectViewTemplate"
	};
</script>

<style scoped>

</style>